export default __webpack_public_path__ + "static/media/manage-content.8d1b2c13.svg";